<!-- Overlay pour fermer les menus au clic extérieur -->
@if (filterMenuOpen() || sortMenuOpen()) {
  <div class="menu-backdrop" (click)="closeMenus()" data-testid="menu-backdrop"></div>
}

<!-- ══ 1. En-tête recueil - Template Angular ...══════════════════════════════════════════════════ -->
<header class="rhead">
  <div class="shell rhead-inner">
    <app-breadcrumb />

    <div class="rhead-grid">
      <!-- Mini-livre -->
      <div class="book" aria-hidden="true" [style.--spine]="spineColor()">
        @if (recueilImageUrl()) {
          <img class="book-img" [src]="recueilImageUrl()!" alt="" />
        } @else {
          <div class="book-cover"></div>
        }
      </div>

      <!-- Identité -->
      <div class="id">
        <div class="ls-eyebrow">Recueil · Tous les chants</div>
        <h1>{{ recueilName() }}</h1>
        <p class="sub">
          @if (countFr() > 0) {
            <span class="mono">{{ countFr() }}</span> chants français
          }
          @if (countFr() > 0 && countHt() > 0) {
            ·
          }
          @if (countHt() > 0) {
            <span class="mono">{{ countHt() }}</span> chants krèyol
          }
        </p>
      </div>

      <!-- Actions rapides -->
      <div class="quick" role="toolbar" aria-label="Actions rapides">
        <button
          class="iconbtn"
          type="button"
          aria-label="Ajouter aux favoris"
          data-testid="btn-fav-recueil"
        >
          <i class="ls-heart"></i>
        </button>
        <button class="iconbtn" type="button" aria-label="Télécharger le PDF" data-testid="btn-pdf">
          <i class="ls-download"></i>
        </button>
        <button class="iconbtn" type="button" aria-label="Partager" data-testid="btn-share">
          <i class="ls-share-2"></i>
        </button>
      </div>
    </div>
  </div>
</header>

<!-- ══ 2. Onglets de langue ════════════════════════════════════════════════ -->
<nav class="langbar" aria-label="Langue">
  <div class="shell langbar-inner">
    @for (tab of langTabs(); track tab.code) {
      <button
        class="langtab"
        [class.on]="recueilLang() === tab.code"
        type="button"
        (click)="setLang(tab.code)"
        [attr.data-testid]="'tab-' + tab.code"
      >
        @if (tab.flagClass) {
          <span class="flag" [ngClass]="tab.flagClass" aria-hidden="true"></span>
        }
        {{ tab.label }}
        @if (tab.count > 0) {
          <span class="ct">{{ tab.count }}</span>
        }
      </button>
    }

    <!-- <button class="langtab locked" type="button" disabled aria-disabled="true" data-testid="tab-en">
      <i class="ls-lock" aria-hidden="true"></i>
      English
      <span class="ct">À venir</span>
    </button> -->
  </div>
</nav>

<div class="shell">
  <!-- ══ 3. Toolbar ═════════════════════════════════════════════════════════ -->
  <div class="toolbar" role="search">
    <!-- Recherche -->
    <label class="search" [class.has-value]="query()">
      <i class="ls-search" aria-hidden="true"></i>
      <input
        #searchInput
        type="text"
        placeholder="Rechercher un chant…"
        [value]="query()"
        (input)="setQuery($any($event.target).value)"
        aria-label="Rechercher"
        data-testid="search-input"
      />
    </label>

    <!-- Filtres -->
    <div class="tool-wrap" [class.open]="filterMenuOpen()">
      <button
        class="tool-select"
        type="button"
        [class.active]="activeFilterCount() > 0"
        (click)="filterMenuOpen.set(!filterMenuOpen()); sortMenuOpen.set(false)"
        aria-haspopup="true"
        [attr.aria-expanded]="filterMenuOpen()"
        data-testid="btn-filters"
      >
        <i class="ls-filter" aria-hidden="true"></i>
        @if (activeFilterCount() > 0) {
          <b>{{ activeFilterCount() }} filtres</b>
        } @else {
          <span class="lbl">Aucun filtre</span>
        }
        <i class="ls-chevron-down chev" aria-hidden="true"></i>
      </button>

      @if (filterMenuOpen()) {
        <div class="menu" role="dialog" aria-label="Filtres" data-testid="filter-menu">
          <div class="menu-section">Chorale</div>
          <label class="menu-item">
            <span class="rd" [class.checked]="filters().chorale === 'all'"></span>
            <input
              type="radio"
              name="chorale"
              value="all"
              [checked]="filters().chorale === 'all'"
              (change)="setChorale('all')"
              hidden
            />
            Tous
          </label>
          <label class="menu-item">
            <span class="rd" [class.checked]="filters().chorale === 'none'"></span>
            <input
              type="radio"
              name="chorale"
              value="none"
              [checked]="filters().chorale === 'none'"
              (change)="setChorale('none')"
              hidden
            />
            Sans chorale
          </label>
          <label class="menu-item">
            <span class="rd" [class.checked]="filters().chorale === 'with'"></span>
            <input
              type="radio"
              name="chorale"
              value="with"
              [checked]="filters().chorale === 'with'"
              (change)="setChorale('with')"
              hidden
            />
            Avec chorale
          </label>

          <div class="menu-divider"></div>
          <div class="menu-section">Médias</div>
          <label class="menu-item">
            <span class="ck" [class.checked]="filters().audio"></span>
            <input type="checkbox" [checked]="filters().audio" (change)="toggleAudio()" hidden />
            Avec audio
          </label>
          <label class="menu-item">
            <span class="ck" [class.checked]="filters().sheet"></span>
            <input type="checkbox" [checked]="filters().sheet" (change)="toggleSheet()" hidden />
            Avec partition
          </label>

          <div class="menu-divider"></div>
          <button
            class="menu-reset"
            type="button"
            (click)="resetFilters()"
            data-testid="btn-reset-filters"
          >
            Réinitialiser
          </button>
        </div>
      }
    </div>

    <!-- Tri -->
    <div class="tool-wrap" [class.open]="sortMenuOpen()">
      <button
        class="tool-select"
        type="button"
        (click)="sortMenuOpen.set(!sortMenuOpen()); filterMenuOpen.set(false)"
        aria-haspopup="true"
        [attr.aria-expanded]="sortMenuOpen()"
        data-testid="btn-sort"
      >
        <i class="ls-sort-asc" aria-hidden="true"></i>
        <span class="lbl"
          >Trier par <b>{{ sortLabel() }}</b></span
        >
        <i class="ls-chevron-down chev" aria-hidden="true"></i>
      </button>

      @if (sortMenuOpen()) {
        <div class="menu" role="dialog" aria-label="Tri" data-testid="sort-menu">
          <div class="menu-section">Trier par</div>
          @for (opt of sortOptions; track opt.value) {
            <label class="menu-item">
              <span class="rd" [class.checked]="sort() === opt.value"></span>
              <input
                type="radio"
                name="sort"
                [value]="opt.value"
                [checked]="sort() === opt.value"
                (change)="setSort(opt.value)"
                hidden
              />
              {{ opt.label }}
            </label>
          }
        </div>
      }
    </div>

    <!-- Bascule vue -->
    <div class="viewtoggle" role="group" aria-label="Vue">
      <button
        type="button"
        [class.on]="view() === 'grid'"
        (click)="setView('grid')"
        aria-label="Vue grille"
        data-testid="btn-view-grid"
      >
        <i class="ls-layout-grid" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        [class.on]="view() === 'list'"
        (click)="setView('list')"
        aria-label="Vue liste"
        data-testid="btn-view-list"
      >
        <i class="ls-list" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Note de résultat -->
    <span class="resnote" aria-live="polite" data-testid="resnote">{{ resnote() }}</span>
  </div>

  <!-- ══ 4. Grille de chants ════════════════════════════════════════════════ -->

  @if (sort() === 'alpha') {
    <!-- Vue alpha : groupes par lettre dans une seule grille .songs -->
    <div class="songs" [class.list]="view() === 'list'" data-testid="songs-grid">
      @for (group of alphaGroups(); track group.letter) {
        <div class="alpha" role="separator">{{ group.letter }}</div>
        @for (lyric of group.songs; track lyric.id) {
          <ls-lyric-card
            [lyric]="lyric"
            [href]="lyricHref(lyric.slug)"
            rankStyle="plain"
            [showPlayOverlay]="true"
            [showArtist]="true"
            [showSigle]="true"
            trailingAction="menu"
            [showOpenLyrics]="true"
            [showListenNow]="true"
            [showPlayNext]="true"
            [showAddToPlaylist]="true"
            [showFavorite]="true"
            [showShare]="true"
            [showContributor]="false"
            [attr.data-testid]="'song-row-' + lyric.id"
          />
        }
      }
      @if (!filteredSongs().length) {
        <div class="empty" data-testid="empty-state">Aucun chant ne correspond à vos critères.</div>
      }
    </div>
  } @else {
    <!-- Vue normale -->
    <ls-lyric-recueil-list
      [items]="displayedSongs()"
      [view]="view()"
      [showNo]="true"
      [numbered]="sort() === 'num'"
      [loading]="loading()"
      [allLoaded]="allLoaded()"
      [lang]="appLang()"
      [showContributor]="false"
      data-testid="songs-grid"
    />
  }

  <!-- Sentinelle scroll infini -->
  <div id="sentinel" aria-hidden="true"></div>

  <!-- Statut scroll -->
  <div id="scroll-status" aria-live="polite" data-testid="scroll-status">
    @if (loading()) {
      <span class="spinner-sm"></span>
      Chargement…
    } @else if (allLoaded() && filteredSongs().length > 0) {
      Fin de la liste · {{ filteredSongs().length }} chants
    }
  </div>
</div>
